import { __decorate } from "tslib";
import { Component, ViewChild } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { WebsiteThemeService } from "../../../../services/website-theme.service";
import { LoginComponent } from "../../../login";
import { ComponentService } from "../../../../services/component.service";
import { Router } from "@angular/router";
import { WebClientService } from "../../../../services/webclient-settings.service";
import { SharedHttp } from "../../../../services/http-client.service";
import { LanguageService } from "../../../../services/language.service";
import { FormBuilder, FormGroup } from "@angular/forms";
let GeneralCompanyInformationComponent = class GeneralCompanyInformationComponent {
    constructor(compService, sanitizer, themeService, router, webSettingsService, httpClient, languageService, formBuilder) {
        this.compService = compService;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.router = router;
        this.webSettingsService = webSettingsService;
        this.httpClient = httpClient;
        this.languageService = languageService;
        this.formBuilder = formBuilder;
        this.secondColor = '';
        this.inputBackColor = '';
        this.inputTextColor = '';
        this.errorColor = '';
        this.textColor = '';
        this.successColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.accentColor = '';
        this.lang = '';
        this.loadingSpinner = false;
        this.vatIdError = false;
        this.vatIdExistsError = false;
        this.registrationNumberError = false;
        this.registrationNumberExistsError = false;
        this.fullNameError = false;
        this.keyword = 'name';
        this.activityCodes = [];
        this.activityCodesByLang = [];
        this.companyActivityCodeError = false;
        this.dropdownActivityCodeInFocus = false;
        this.companyTypes = [];
        this.companyTypeError = false;
        this.dropdownCompanyTypeInFocus = false;
        this.baseCompanyData = {
            vatId: undefined,
            registrationNumber: undefined,
            fullName: undefined,
            activityCode: undefined,
            companyTypeCode: undefined,
            shortName: undefined
        };
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.inputBackColor = this.themeService.getStyleAttribute('input_background_color');
            this.inputTextColor = this.themeService.getStyleAttribute('input_text_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
        });
        this.languageService.getChosenLanguage().subscribe((lang) => {
            var _a;
            this.lang = lang ? lang : 'en';
            this.activityCodesByLang = this.activityCodes ? this.activityCodes.filter(activityCode => activityCode.lang_name === this.lang) : [];
            if (this.baseCompanyData.activityCode) {
                this.activityCodesForm.get('activityCodesAutoComplete').patchValue((_a = this.activityCodesByLang.find(activityCode => activityCode.id === this.baseCompanyData.activityCode)) === null || _a === void 0 ? void 0 : _a.name);
            }
        });
        this.activityCodesForm = this.formBuilder.group({
            activityCodesAutoComplete: ''
        });
        this.companyTypesForm = this.formBuilder.group({
            companyTypesAutoComplete: ''
        });
    }
    ngOnInit() {
        var _a;
        if ((_a = this.data) === null || _a === void 0 ? void 0 : _a.baseCompanyData) {
            this.baseCompanyData = this.data.baseCompanyData;
        }
        this.getActivityCodes();
        this.getCompanyTypes();
    }
    ngAfterViewInit() {
        const activityCodesAutoCompleteListElement = this.activityCodesAutoComplete.elementRef.nativeElement.querySelector('ul');
        activityCodesAutoCompleteListElement.className = 'activityCodesList';
        const activityCodesAutoCompleteInputElement = this.activityCodesAutoComplete.elementRef.nativeElement.querySelector('input');
        activityCodesAutoCompleteInputElement.id = 'activityCode';
        const companyTypesAutoCompleteListElement = this.companyTypesAutoComplete.elementRef.nativeElement.querySelector('ul');
        companyTypesAutoCompleteListElement.className = 'companyTypesList';
        const companyTypesAutoCompleteInputElement = this.companyTypesAutoComplete.elementRef.nativeElement.querySelector('input');
        companyTypesAutoCompleteInputElement.id = 'companyType';
    }
    getActivityCodes() {
        this.httpClient.get('user/activitycodes').subscribe((data) => {
            var _a;
            this.activityCodes = data;
            this.activityCodesByLang = this.activityCodes ? this.activityCodes.filter(activityCode => activityCode.lang_name === this.lang) : [];
            if (this.baseCompanyData.activityCode) {
                this.activityCodesForm.get('activityCodesAutoComplete').patchValue((_a = this.activityCodesByLang.find(activityCode => activityCode.id === this.baseCompanyData.activityCode)) === null || _a === void 0 ? void 0 : _a.name);
            }
        });
    }
    getCompanyTypes() {
        this.httpClient.get('user/companytypes').subscribe((data) => {
            var _a;
            this.companyTypes = data;
            if (this.baseCompanyData.companyTypeCode) {
                this.companyTypesForm.get('companyTypesAutoComplete').patchValue((_a = this.companyTypes.find(companyType => companyType.code === this.baseCompanyData.companyTypeCode)) === null || _a === void 0 ? void 0 : _a.name);
            }
        });
    }
    setActivityCode(item) {
        this.baseCompanyData.activityCode = item.id;
        this.checkActivityCode();
    }
    setCompanyType(item) {
        this.baseCompanyData.companyTypeCode = item.code;
        this.checkCompanyType();
    }
    checkActivityCode() {
        this.companyActivityCodeError = this.baseCompanyData.activityCode === 'null' || this.baseCompanyData.activityCode === undefined;
        return !this.companyActivityCodeError;
    }
    checkCompanyType() {
        this.companyTypeError = this.baseCompanyData.companyTypeCode === 'null' || this.baseCompanyData.companyTypeCode === undefined;
        return !this.companyTypeError;
    }
    onClearActivityCode() {
        this.baseCompanyData.activityCode = null;
    }
    onClearCompanyType() {
        this.baseCompanyData.companyTypeCode = null;
    }
    onFocusedActivityCode(e) {
        this.dropdownActivityCodeInFocus = e;
        this.companyActivityCodeError = !e && !this.baseCompanyData.activityCode;
    }
    onFocusedCompanyType(e) {
        this.dropdownCompanyTypeInFocus = e;
        this.companyTypeError = !e && !this.baseCompanyData.companyTypeCode;
    }
    checkVatId() {
        this.vatIdError = false;
        this.vatIdExistsError = false;
        if (!this.baseCompanyData.vatId || !/^[0-9]{9}$/.test(this.baseCompanyData.vatId)) {
            this.vatIdError = true;
            return false;
        }
        else {
            return this.httpClient.post('user/checkvatid', { vatid: this.baseCompanyData.vatId.trim() }).subscribe((data) => {
                return true;
            }, (error) => {
                var _a;
                this.vatIdExistsError = ((_a = error === null || error === void 0 ? void 0 : error.error) === null || _a === void 0 ? void 0 : _a.message) === 'COMPANY_WITH_VAT_ID_ALREADY_EXISTS';
                this.vatIdError = !this.vatIdExistsError;
                return false;
            });
        }
    }
    checkRegistrationNumber() {
        this.registrationNumberError = false;
        this.registrationNumberExistsError = false;
        if (!this.baseCompanyData.registrationNumber || !/^[0-9]{8}$/.test(this.baseCompanyData.registrationNumber)) {
            this.registrationNumberError = true;
            return false;
        }
        else {
            return this.httpClient.post('user/checkregistrationnumber', { registrationnumber: this.baseCompanyData.registrationNumber.trim() }).subscribe((data) => {
                return true;
            }, (error) => {
                var _a;
                this.registrationNumberExistsError = ((_a = error === null || error === void 0 ? void 0 : error.error) === null || _a === void 0 ? void 0 : _a.message) === 'COMPANY_REGISTRATION_NUMBER_ALREADY_EXISTS';
                this.registrationNumberError = !this.registrationNumberExistsError;
                return false;
            });
        }
    }
    checkFullName() {
        this.fullNameError = this.baseCompanyData.fullName === undefined || this.baseCompanyData.fullName.length < 2;
        if (!this.fullNameError) {
            this.baseCompanyData.shortName = this.baseCompanyData.fullName;
        }
        return !this.fullNameError;
    }
    checkIfFormIsValid() {
        return Object.values(this.baseCompanyData).some(field => field === undefined || field === null || field === '')
            || this.vatIdError || this.vatIdExistsError || this.registrationNumberError
            || this.registrationNumberExistsError || this.fullNameError || this.companyActivityCodeError || this.companyTypeError;
    }
    goToTheNextStep() {
        if (this.checkVatId() && this.checkRegistrationNumber() && this.checkFullName() && this.checkActivityCode() && this.checkCompanyType()) {
            this.loadingSpinner = true;
            this.success({ registerData: this.data.registerData, baseCompanyData: this.baseCompanyData });
            this.close();
        }
    }
    alreadyHave() {
        this.modal.destroy();
        this.compService.openModal(LoginComponent);
    }
    close() {
        document.body.className = '';
        this.router.navigateByUrl('/');
        this.modal.destroy();
    }
    goBack() {
        this.error({ registerData: this.data.registerData });
        document.body.className = '';
        this.modal.destroy();
    }
};
GeneralCompanyInformationComponent.ctorParameters = () => [
    { type: ComponentService },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: Router },
    { type: WebClientService },
    { type: SharedHttp },
    { type: LanguageService },
    { type: FormBuilder }
];
__decorate([
    ViewChild('activityCodesAutoComplete')
], GeneralCompanyInformationComponent.prototype, "activityCodesAutoComplete", void 0);
__decorate([
    ViewChild('companyTypesAutoComplete')
], GeneralCompanyInformationComponent.prototype, "companyTypesAutoComplete", void 0);
GeneralCompanyInformationComponent = __decorate([
    Component({
        selector: 'app-general-company-information',
        template: __importDefault(require("./general-company-information.component.html")).default,
    })
], GeneralCompanyInformationComponent);
export { GeneralCompanyInformationComponent };
